<script setup lang="ts">
import organizationApi from '@/services/organization.service'
import store from '@/store'
import { EAlertActions } from '@/store/alertStore/AlertStoreTypes'
import { EStoreModules } from '@/store/storeType'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import NetworksSelector from '../../../components/Selector/components/NetworksSelector.vue'
import type { NetworkModel } from '../../../types/models/NetworkModel'
import DeviceRentalActions from './DeviceRentalActions.vue'

type Props = {
    deviceId: number
}
const props = defineProps<Props>()
type Emits = {
    (e: 'refresh'): void
}
const emit = defineEmits<Emits>()

const { t } = useI18n()

const organizationId = computed(() => store.state.authentication.me.organization_id)
const loading = ref(false)
const open = ref(false)
const selectedOrganization = ref<NetworkModel>()
const date = ref({
    start_at: new Date(),
    end_at: new Date()
})

const confirmRental = () => {
    if (!organizationId.value || !selectedOrganization.value) return
    loading.value = true
    organizationApi
        .createRental(organizationId.value, {
            ...date.value,
            device_id: props.deviceId,
            renter_id: selectedOrganization.value?.party_id
        })
        .then(() => {
            open.value = false
            date.value = {
                start_at: new Date(),
                end_at: new Date()
            }
            selectedOrganization.value = undefined
            store.dispatch(`${EStoreModules.ALERT}/${EAlertActions.QUEUE_ITEM}`, {
                action: EAlertActions.SUCCESS,
                message: t('device.rental.rentalApiSuccess')
            })
        })
        .finally(() =>
            setTimeout(() => {
                emit('refresh')
                loading.value = false
            }, 5000)
        )
}
</script>

<template>
    <DeviceRentalActions
        :loading="loading"
        :open="open"
        :valueDate="date"
        @change="date = { ...date, ...$event }"
        @confirm="confirmRental"
        @open="open = $event">
        <NetworksSelector
            :label="$t('device.rental.rentToOrganization')"
            :organizationId="selectedOrganization?.party_id"
            @select="selectedOrganization = $event"
            class="fixed-dialog-dropdown modal-selector-full-width" />
    </DeviceRentalActions>
</template>
